var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.promoter == 'Y')?_c('Promote'):(_vm.promoter == 'N' && _vm.companies&&_vm.companies.status == 1000)?_c('PromoteStatus'):(_vm.promoter == 'N' && _vm.companies&&_vm.companies.status == 1006)?_c('PromoteStatus'):(_vm.promoter == 'N')?_c('PromoteRule'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }